import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import ActionBar from './components/ActionBar';
import { HostData } from './components/HostData';
import Description from './components/Description';
import Resolution from './components/Resolution';
import References from './components/References';
import Policies from './components/Policies';
import ImpactsTab from './components/ImpactsTab';
import Owner from './components/Owner';
import ExternalId from './components/ExternalId';
import Tags from './components/Tags';
import RiskAndCVE from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/RiskAndCVE';
import ToggleButtons from 'Screens/Contextualization/Manage/components/ToggleButtons';
import { Wrapper, Fields } from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/styled';
import ToolsHistory from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/ToolsHistory';
import { selectVulnDetail, selectIsFetchingVulnEnrichment } from 'store/ManageGeneral/selectors';
import { refreshVulnEnrichment, updateVulnGeneral } from 'store/ManageGeneral/actions';
import { selectTempCVSSVector } from 'store/Manage/selectors';
import { resetCVSS } from 'store/Manage/actions';
import Duplicates from './components/Duplicates';

const GeneralTab = () => {
  const vulnDetail = useSelector(selectVulnDetail);
  const tempCVSS = useSelector(selectTempCVSSVector);
  const fetchingVulnEnrichment = useSelector(selectIsFetchingVulnEnrichment);
  const refElement = useRef();

  const scrollToReferences = () => refElement.current.scrollIntoView({ behavior: 'smooth' });

  return (
    <Wrapper>
      <Duplicates />
      <ActionBar />
      <HostData />
      <ToggleButtons id="general" />
      <Fields>
        <RiskAndCVE
          scrollToReferences={ scrollToReferences }
          currentVuln={ vulnDetail }
          updateVuln={ updateVulnGeneral }
          tempCVSS={ tempCVSS }
          refreshVulnEnrichment={ refreshVulnEnrichment }
          resetCVSS={ resetCVSS }
          entity="vulnsGeneral"
          fetchingVulnEnrichment={ fetchingVulnEnrichment }
        />
        <Description />
        <Resolution />
        <Tags />
        <References refElement={ refElement } />
        <ImpactsTab />
        <Policies />
        <ExternalId />
        <Owner />
        <ToolsHistory vuln={ vulnDetail } />
      </Fields>
    </Wrapper>
  );
};
export default GeneralTab;
